module.exports = __webpack_public_path__ + "static/img/coupon@2x.e5367b2d.png";